export const rtiTranslations = {
  en: () =>
    import('@recruitee/integrations/locales/en.json').then(translations => ({
      en: translations.default,
    })),
  de: () =>
    import('@recruitee/integrations/locales/de.json').then(translations => ({
      de: translations.default,
    })),
  fr: () =>
    import('@recruitee/integrations/locales/fr.json').then(translations => ({
      fr: translations.default,
    })),
  nl: () =>
    import('@recruitee/integrations/locales/nl.json').then(translations => ({
      nl: translations.default,
    })),
  sv: () =>
    import('@recruitee/integrations/locales/sv.json').then(translations => ({
      sv: translations.default,
    })),
  fi: () =>
    import('@recruitee/integrations/locales/fi.json').then(translations => ({
      fi: translations.default,
    })),
};
